import Axios from 'axios'
import moment from 'moment'
import store from '../store'
import AuthService from './auth_service'
import Vue from 'vue'

export default class Service {
  static url = 'https://jt.s2.rpn.ch/api'
  static portfolioUrl = 'https://portfolio.s2.rpn.ch/api/v1'
  static portfolioToken = '3c1f665a-3afc-46c0-ab5a-800cd16be63d'
  /**
   * Instance Axios pour effectuer les requêtes à l'API JT
   */
  static api = Axios.create({
    baseURL: this.url
  })
  /**
   * Instance Axios pour effectuer les requêtes à l'API Portfolio
   */
  static portfolioApi = Axios.create({
    baseURL: this.portfolioUrl
  })
  /**
   * Récupère l'en-tête Autorization pour s'authentifier auprès de l'API JT
   * @param {string} token
   */
  static getAuthHeader (token) {
    return {
      Authorization: 'Bearer ' + token
    }
  }
  /**
   * Récupère l'en-tête Autorization pour s'authentifier auprès de l'API Portfolio
   * @param {string} token
   */
  static getPortfolioAuthHeader (token) {
    return {
      'Content-Type': 'application/json',
      Token: token
    }
  }
  /**
   * Teste si l'access token doit être renouvelé, le renouvelle si c'est le cas
   */
  static verifyToken () {
    return new Promise(async (resolve, reject) => {
      // Le token est expiré ?
      if (moment().unix() >= store.state.auth.user.token.expiresIn) {
        const refreshToken = localStorage.getItem('refreshToken')
        // api : renouvelle le token
        const response = await AuthService.renewAccessToken(refreshToken)
        if (response) {
          const data = response.data.data
          // Set refreshToken dans localstorage
          localStorage.setItem('refreshToken', data.refresh_token)
          // Peupler user avec les information codée du token
          store.dispatch('auth/setUserFromToken', data.access_token)
          const token = {
            accessToken: data.access_token,
            expiresIn: data.expires_in
          }
          store.dispatch('auth/setUserToken', token)
          resolve()
        } else {
          reject(new Error('Une erreur inconnue est survenue, veuillez réessayer'))
        }
      } else {
        resolve()
      }
    })
  }
  /**
   * Log l'erreur dans la console et affiche le message à l'utilisateur
   * @param {Error} error
   */
  static handleError (error) {
    console.log(error)
    error.response ? Vue.prototype.$message.error('Erreur code ' + error.response.data.status.code, 5) : Vue.prototype.$message.error('Une erreur inconnue est survenue, veuillez réessayer', 5)
  }
}
